var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWishlist(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 51.166,
    height: 49.224,
    viewBox: "0 0 51.166 49.224",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5770",
    "data-name": "Group 5770",
    transform: "translate(-59.676 -40)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5768",
    "data-name": "Group 5768",
    transform: "translate(6268.676 6666)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_21452079141582962144",
    "data-name": 21452079141582963000,
    transform: "translate(-6209 -6626)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6161",
    "data-name": "Path 6161",
    d: "M91.221,76.044a5.991,5.991,0,0,0-8.473,0l-1.36,1.36-1.36-1.36A5.992,5.992,0,0,0,69.8,80.281a8.91,8.91,0,0,0,2.14,5.153,49.189,49.189,0,0,0,3.981,4.74A33.508,33.508,0,0,0,80.59,94.3a1.114,1.114,0,0,0,1.595,0,33.507,33.507,0,0,0,4.67-4.122,49.19,49.19,0,0,0,3.981-4.74,8.91,8.91,0,0,0,2.14-5.153A5.973,5.973,0,0,0,91.221,76.044Z",
    transform: "translate(-41.81 -45.408)",
    fill: "#fc4755"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6162",
    "data-name": "Path 6162",
    d: "M46.609,32.693H27.483a1.277,1.277,0,0,0,0,2.553H46.609a1.277,1.277,0,1,0,0-2.553Z",
    transform: "translate(-16.304 -21.071)",
    fill: "#2196f3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6163",
    "data-name": "Path 6163",
    d: "M46.609,54.364H27.483a1.277,1.277,0,0,0,0,2.553H46.609a1.277,1.277,0,1,0,0-2.553Z",
    transform: "translate(-16.304 -33.75)",
    fill: "#2196f3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6164",
    "data-name": "Path 6164",
    d: "M36.928,76.036H27.483a1.277,1.277,0,0,0,0,2.553h9.445a1.277,1.277,0,1,0,0-2.553Z",
    transform: "translate(-16.304 -46.43)",
    fill: "#2196f3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6165",
    "data-name": "Path 6165",
    d: "M41.919,4.682H4.246a1.905,1.905,0,0,0-1.9,1.9V52a1.905,1.905,0,0,0,1.9,1.9H38.293a38.152,38.152,0,0,1-3.284-3.079q-.344-.361-.684-.731H6.151V8.492H40.014V32.468a7.991,7.991,0,0,1,1.9,1.389,8.009,8.009,0,0,1,1.9-1.389V6.587a1.9,1.9,0,0,0-1.905-1.9Z",
    transform: "translate(-2.342 -4.682)",
    fill: "#607d8b"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWishlist);
export default __webpack_public_path__ + "static/media/Wishlist.a053e38fef8ac767afc4a48c9da4705b.svg";
export { ForwardRef as ReactComponent };